<div class="box drop-zone-box" ngx-dropzone (change)="onDropzoneSelect($event)">
  <ngx-dropzone-label>
    <p>
      <mat-icon>cloud_upload</mat-icon>
      <br>
      Drop files here or click to select files
    </p>
  </ngx-dropzone-label>
  @for (f of images(); track f) {
    <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" [file]="f"
      [removable]="false" (removed)="dropzoneRemove(f)">
    </ngx-dropzone-image-preview>
  }
  @for (f of videos(); track f) {
    <ngx-dropzone-video-preview ngProjectAs="ngx-dropzone-preview" [file]="f"
      [removable]="false" (removed)="dropzoneRemove(f)">
    </ngx-dropzone-video-preview>
  }
  @for (f of others(); track f) {
    <ngx-dropzone-preview [file]="f" [removable]="false" (removed)="dropzoneRemove(f)">
      <ngx-dropzone-label>{{ f.name }} | {{ f.type }} | {{f.size}}</ngx-dropzone-label>
    </ngx-dropzone-preview>
  }
</div>

<p>
  <span class="warn">Supported font extensions (*.ttf, *.woff, *.woff2, *.eot, *.otf)</span>
  <br>
  <span class="warn">Files are deleted when the campaign is deleted!</span>
</p>
  <div fxLayout="column" fxFlexFill>
    <ngx-datatable #datatable
      class="material mat-typography fullscreen"
      [rows]="mediaOjects"
      [columnMode]="ColumnMode.force"
      [headerHeight]="headerHeight"
      [rowHeight]="rowHeight"
      >

      <ngx-datatable-column name="Key" [sortable]="false" [canAutoResize]="true" [draggable]="false" [resizeable]="false">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <a class="action-button" href="{{row.url}}" target="_blank">{{ getCleanKey(row.key) }}</a>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Last modified" [sortable]="true" [canAutoResize]="false" [draggable]="false" [resizeable]="false">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <span>{{ row.lastModified | date:'short' }}</span>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="" [sortable]="false" [canAutoResize]="false" [draggable]="false" [resizeable]="false">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <lib-button variant="icon" color="primary" icon="content_copy" tooltip="Copy url to clipboard" ngxClipboard [cbContent]="row.url"></lib-button>
        </ng-template>
      </ngx-datatable-column>

    </ngx-datatable>

  </div>